var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCertified(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "22px",
    viewBox: "0 0 44 61",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "certified",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "certified") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd",
    fill: "#27CAD5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "certified_c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5782,26.4911 L20.7812,37.2871 C20.3652,37.7031 19.7172,37.7501 19.2482,37.4321 C19.1762,37.3871 19.1102,37.3351 19.0492,37.2751 L12.8672,31.2081 C12.3932,30.7421 12.3852,29.9721 12.8522,29.4991 L14.3542,27.9671 C14.8202,27.4931 15.5892,27.4861 16.0642,27.9521 L19.9002,31.7171 L28.3522,23.2651 C28.8212,22.7951 29.5912,22.7951 30.0612,23.2651 L31.5782,24.7821 C32.0482,25.2511 32.0482,26.0211 31.5782,26.4911 M42.3952,8.8401 C35.1292,8.6731 30.1332,6.8981 23.0972,0.8171 C22.5922,0.3801 21.7872,0.3791 21.2812,0.8161 C14.2462,6.8971 9.2502,8.6731 1.9842,8.8401 C1.3162,8.8551 0.7742,9.3941 0.7742,10.0621 L0.7742,32.8581 C0.7742,43.9401 8.1902,51.1111 21.1842,59.8441 C21.7382,60.2161 22.6402,60.2161 23.1942,59.8441 C36.1882,51.1111 43.6042,43.9401 43.6042,32.8581 L43.6042,10.0621 C43.6042,9.3941 43.0632,8.8551 42.3952,8.8401"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertified);
export default __webpack_public_path__ + "assets/media/certified.7247c04bb1c969dae0894ae61a461d3b.svg";
export { ForwardRef as ReactComponent };